import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSolutionSection } from '../components/ProblemSolutionSection';
import { ProductDetailsSection } from '../components/ProductDetailsSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { SalesNotification } from '../components/SalesNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-brand-text selection:bg-brand-mint selection:text-brand-dark" data-id="element-254">
      <HeroSection data-id="element-255" />
      <ProblemSolutionSection data-id="element-256" />
      <ProductDetailsSection data-id="element-257" />
      <SocialProofSection data-id="element-258" />
      <FAQSection data-id="element-259" />
      <CTASection data-id="element-260" />
      <Footer data-id="element-261" />
      <SalesNotification data-id="element-262" />
    </div>;
}